

function text(){
  var line = $('.hero-section .marquee-snap .line');

var tl = new TimelineLite({
			onComplete: function(){
				tl.restart();
			}
		});
TweenLite.defaultEase = Circ.easeInOut;

var time = 0.9;
var y = 100;

tl
	.add ( TweenMax.staggerFromTo (
		line, time,
			{
				opacity: 0,
				y:y,
			},
			{	
				opacity: 1,
				y: 0,
              letterSpacing:"5px",
              
			},
		2 ))
	.add ( TweenMax.staggerTo (
		line, time,
			{
				delay: time,
				opacity: 0,
				y: -y,
			},
		2 ), 1.3)
}
text();